import _ from 'lodash'
import { StepSchema } from '@feedyou/schema'
import { isNotEmptyElement, isNotEmptyStringOrWhiteSpace } from '@feedyou/utils'

import { getStorageNamesFromIntegrationStorageSchema } from '../utils'

export const extractIntegrationStorages = (allSteps: StepSchema[]) => {
  const integrationSteps = allSteps.filter(step => step.type === 'integration')

  const integrationStorageNames = extractStorageNamesFromIntegrationSteps(integrationSteps)
  const integrationStorageSchemaNames = integrationSteps
    .map(step => getStorageNamesFromIntegrationStorageSchema(step.service, step.action))
    .flat()

  return _.uniq([...integrationStorageNames, ...integrationStorageSchemaNames]).map(name => ({
    name,
    storageType: ['integration']
  }))
}

function extractStorageNamesFromIntegrationSteps(integrationSteps: StepSchema[]): string[] {
  return Object.values(
    integrationSteps
      .filter(step => !!findStorageSectionKeyInIntegrationStep(step))
      .map(step => {
        const key = findStorageSectionKeyInIntegrationStep(step)
        return Array.isArray(step[key!])
          ? step[key!].map((prop: any) => prop.storage).filter(isNotEmptyStringOrWhiteSpace)
          : null
      })
      .flat()
      .filter(isNotEmptyElement)
  )
}

function findStorageSectionKeyInIntegrationStep(step: StepSchema): string | undefined {
  return ['outputs', 'storages', 'attachments'].find(key => !!step[key]?.length)
}
